import { Form as AntForm, Select } from 'antd';
import { AnySchema } from 'yup';
import { Controller, Control } from 'react-hook-form';
import { formHelpers } from '@helpers/formHelpers';

const { Item: FormItem } = AntForm;

interface HSMSDatePickerProps {
  label: string;
  name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  validationSchema?: AnySchema;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors?: any; // If we are setting proper types we need to get the form values. Not possible since we use this in multiple forms
}

export const HSMSTagSelect = ({ label, name, control, validationSchema, errors }: HSMSDatePickerProps) => (
  <FormItem
    label={label}
    required={validationSchema && formHelpers.isRequired(validationSchema, name)}
    validateStatus={errors && errors[name] ? 'error' : ''}
    help={errors && errors[name]?.message}
    labelCol={{ span: 24 }}
  >
    <Controller as={<Select mode="tags" />} name={name} control={control} />
  </FormItem>
);
